import { Modal, IModalProps } from './Modal';

import './Modal.css';

export { Modal, IModalProps };
export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.ts